import { SentryLoggable } from "@zapier/payment/esm/errors/SentryLoggable";

export * from "./setup-intents/index";

export class FatalError extends Error implements SentryLoggable {
  transactionName = "paymentSource.save";
}
export class ValidationError extends Error implements SentryLoggable {
  transactionName = "paymentSource.save";
}
